export default  (offset = 106) => {
    const { hash } = window.location;
    if (!hash) return;
    try {
        const target = document.querySelector(hash);
        if (!target) return;
        const top = window.pageYOffset + target.getBoundingClientRect().top - offset;
        requestAnimationFrame(() =>
            window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' })
        );
    } catch {
        /* ignore */
    }
};
